"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "firmo": {
    "91d5b1ca": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "skipSearch": false
    }],
    "chiuse": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "74f93056": [{
      "hkey": "8f651901",
      "slug": "cerzitello",
      "name": "Cerzitello",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-cerzitello": [{
      "hkey": "8f651901",
      "slug": "cerzitello",
      "name": "Cerzitello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d533053b": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "skipSearch": false
    }],
    "foresta": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc39572d": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "skipSearch": false
    }],
    "lipari": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "164ec01d": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "skipSearch": false
    }],
    "lombardi": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "839c1b58": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "skipSearch": false
    }],
    "manche": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "36b904ce": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "skipSearch": false
    }],
    "san-brancato": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "070d42fa": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "skipSearch": false
    }],
    "sciolle": [{
      "hkey": "be1dbe15",
      "slug": "firmo",
      "name": "Firmo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;